import { CharacterRole } from 'app/frontend/types/custom'
import ApplicationRole from 'app/frontend/types/custom/ApplicationRole'
import { imageUrl } from '../helpers'

interface Props {
  role: CharacterRole | ApplicationRole
  size?: 'small' | 'medium' | 'large' | 'custom'
  className?: string
}

const CharacterRoleIcon = ({ role, size, className }: Props) => {
  const sizeStyles = {
    small: 'w-4 h-4 min-w-4 min-h-4',
    medium: 'w-6 h-6 min-w-6 min-h-6',
    large: 'w-8 h-8 min-w-8 min-h-8',
    custom: '',
  }[size ?? 'medium']

  return (
    <img
      src={imageUrl(`roles/${role.toLowerCase()}.png`)}
      className={`rounded-full border border-[#666] ${sizeStyles} ${
        className ?? ''
      }`}
      alt={role}
    />
  )
}

export default CharacterRoleIcon
